import { Component, Currency } from 'macguffin'
import BackgroundImage from "utils/BackgroundImage"

const LABEL_SCALE = 0.65
const VALUE_SCALE = 0.4

const jackpotStyle = {
    backgroundPosition: "bottom center"
}

const ringAssets = [
    "marsPinkRing",
    "marsGreenRing",
    "marsOrangeRing",
    "marsBlueRing"
]

const colourAssets = [
    "pickPinkNormal",
    "pickGreenNormal",
    "pickOrangeNormal",
    "pickBlueNormal"
]

const arrowAssets = [
    "marsPinkArrow",
    "marsGreenArrow",
    "marsOrangeArrow",
    "marsBlueArrow"
]

const colourStyle = {
    backgroundPosition: "center center"
}

const arrowStyle = {
     backgroundPosition: "center center"
}

export default class LandingZone extends Component {

    constructor() {
        super()
    }

    renderResult = () => {
        const { props } = this
        const { width, height, prize } = props

        if (prize === "JACKPOT") {
            return <BackgroundImage className="landingZoneJackpot" assetName="marsSummaryJackpot" style={jackpotStyle}/>
        }

        const valueStyle = {
            fontSize: `${height * VALUE_SCALE}px`
        }

        return <h1 className="landingZoneValue" style={valueStyle}>
            {Currency.format(prize)}
        </h1>
    }

    render() {
        const { props, state, renderResult } = this
        const { index, left, width, height, letter, prize, onSelect, selected } = props
        const onClick = () => { onSelect && onSelect(index) }

        const landingZoneStyle = {
            left: `${left}%`,
            width: `${width}px`,
            height: `${height}px`,
            backgroundPosition: "center center"
        }

        let selectedStyle = { filter: "none" }
        if (prize && selected !== undefined && selected !== index) {
            selectedStyle = {
                filter: "grayscale(100%)"
            }
        }

        const pickLabelStyle = {
            fontSize: `${height * LABEL_SCALE}px`
        }

        return <BackgroundImage className="landingZone" assetName={ringAssets[index]} style={landingZoneStyle} onClick={onClick}>
            <BackgroundImage className="landingZoneColour" assetName={colourAssets[index]} style={{...colourStyle, ...selectedStyle}}>
                <h1 style={pickLabelStyle}>{letter}</h1>
            </BackgroundImage>
            { !prize && <BackgroundImage className="landingZoneArrow" assetName={arrowAssets[index]} style={arrowStyle}/> || renderResult() }
        </BackgroundImage>
    }
}
